import { configureStore } from '@reduxjs/toolkit'

import { getSummary } from './actions/actions'
import reducers from './reducers/reducers'
import getPreloadedState from './utils/preloadedState'

export default function createStore() {
  const store = configureStore({
    reducer: reducers,
    devTools: process.env.NODE_ENV !== 'production',
    preloadedState: getPreloadedState()
  })

  store.subscribe(() => {
    store.dispatch(getSummary())
    window.digiData = JSON.parse(JSON.stringify(store.getState().digiData))
  })

  return store
}
